//记得在 src\components\lang\zhLoad.js 里面添加对象
const paymentConfirmation = {
  msg: {
  }
};
export default paymentConfirmation



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionConfirm/lang/collectionConfirm.en.js